/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   CCPA Module Data Reducer
 */

import { payloadKeyReducer } from '@zcode/reducers'
import type { CcpaRequest } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleAction } from 'redux-actions'
import type * as actions from '../actions/index'
import { SET_CCPA_REQUEST } from '../constants/index'

type Actions = ExtractActions<Values<typeof actions>>

export const ccpaRequest = combineReducers<CcpaRequest>({
  authorizedAgentEmail: handleAction<
    CcpaRequest['authorizedAgentEmail'],
    Actions,
    typeof SET_CCPA_REQUEST
  >(SET_CCPA_REQUEST, payloadKeyReducer('authorized_agent_email'), null),
  authorizedAgentFullName: handleAction<
    CcpaRequest['authorizedAgentFullName'],
    Actions,
    typeof SET_CCPA_REQUEST
  >(SET_CCPA_REQUEST, payloadKeyReducer('authorized_agent_full_name'), null),
  isUser: handleAction<CcpaRequest['isUser'], Actions, typeof SET_CCPA_REQUEST>(
    SET_CCPA_REQUEST,
    payloadKeyReducer('is_user'),
    false
  ),
  status: handleAction<CcpaRequest['status'], Actions, typeof SET_CCPA_REQUEST>(
    SET_CCPA_REQUEST,
    payloadKeyReducer('status'),
    null
  ),
  token: handleAction<CcpaRequest['token'], Actions, typeof SET_CCPA_REQUEST>(
    SET_CCPA_REQUEST,
    payloadKeyReducer('confirmation_token'),
    null
  ),
})
